export default __webpack_public_path__ + "static/media/tat_2_resize.50853bbb.png";